import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatModal = createCustomElementWrapper('kat-modal', 'KatModal', {
    'noCloseIcon': 'no-close-icon',
    'scrollAll': 'scroll-all',
}, {
    'onClose': 'close',
    'onOpen': 'open',
}, [
    'title',
    'footer',
]);
